import { Component } from '@angular/core';
import { FormControl, Validators, FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { AlertService, AuthenticationService, PasswordChangeRejected } from 'src/app/_services';


export const repeatedPasswordMatches: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const newPassword = control.get('newPassword')?.value;
  const repeatNewPassword = control.get('repeatNewPassword')?.value;

  return newPassword && repeatNewPassword && newPassword != repeatNewPassword ? { passwordsDontMatch: true } : null;
};

export function matchesRegex(regex: RegExp, name: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const success = regex.test(control.value);
    return success ? null : {didnMatchRegex: name};
  };
}

@Component({
  selector: 'authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']
})
export class AuthenticationComponent {

  passwordForm = new FormGroup({
    oldPassword: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [
      Validators.required, 
      Validators.minLength(12), 
      matchesRegex(/.*\d+.*/, "containsDigit"),
      matchesRegex(/.*[A-Z]+.*/, "containsUppercase"),
      matchesRegex(/.*[a-z]+.*/, "containsLowercase"),
      matchesRegex(/.*[\s!@#\$%\^\&*\)\(+=._-].*/, "containsSpecialOrWhitespace"),
      matchesRegex(/^(?!\s).*(?!\s)/g, "startOrEndsWithWhitespace")]),
    repeatNewPassword: new FormControl('', [Validators.required])
  }, { validators: repeatedPasswordMatches });

  constructor(
    private authService: AuthenticationService,
    private alertService: AlertService) {
  }
  
  get canChangePassword(): boolean {
    return this.authService.hasPassword();
  }
  
  async changePassword() {
    if (this.passwordForm.valid) {
      
      const changePasswordResult = await this.authService.changePassword(
        this.passwordForm.controls.oldPassword.value!,
        this.passwordForm.controls.newPassword.value!)
        
      if (changePasswordResult instanceof PasswordChangeRejected) {
        this.alertService.showError(changePasswordResult.reasonMessage);
        return;
      }
      
      this.alertService.showSuccess($localize `Password changed`);
      
      await this.authService.globalLogout();
    }
  }
}
